import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import "../css/customservice.scss";

const toTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const JEWELRY_IMAGES = [
  "/main/jew.png",
  "/main/jew1.png",
  "/main/jew2.png",
  "/main/jew3.png",
];

function CustomService() {
  return (
    <div className="custom-service">
      <Header />

      <main
        className="custom-service__main"
        id="MainContent"
        role="main"
        tabIndex={-1}
      >
        <header
          className="custom-service__hero"
          aria-labelledby="custom-service-heading"
        >
          <div className="custom-service__hero-inner">
            <Link
              className="custom-service__back"
              to="/"
              onClick={toTop}
              aria-label="Back to Home"
            >
              <svg
                className="custom-service__back-icon"
                xmlns="http://www.w3.org/2000/svg"
                width={6}
                height={11}
                viewBox="0 0 6 11"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M0.308181 5.59453C0.313452 5.77902 0.381976 5.9477 0.529569 6.08475L4.63054 10.0908C4.7465 10.2068 4.89409 10.2701 5.06804 10.2701C5.41594 10.2701 5.69531 9.99595 5.69531 9.64806C5.69531 9.47938 5.62679 9.31597 5.50555 9.19474L1.81046 5.5998L5.50555 1.99432C5.62152 1.87309 5.69531 1.71495 5.69531 1.541C5.69531 1.19311 5.41594 0.919006 5.06804 0.919006C4.8941 0.919006 4.7465 0.98226 4.63054 1.09823L0.529569 5.10958C0.381976 5.2519 0.308181 5.41004 0.308181 5.59453Z"
                  fill="currentColor"
                />
              </svg>
              <span>Home</span>
            </Link>
            <h1 id="custom-service-heading" className="custom-service__title">
              Customization Services
            </h1>
          </div>
        </header>

        <section
          className="custom-service__body"
          aria-labelledby="custom-service-intro-heading"
        >
          <div className="custom-service__inner">
            <h2
              id="custom-service-intro-heading"
              className="custom-service__subhead"
            >
              Create Something Unique
            </h2>
            <p className="custom-service__lead">
              We offer bespoke customization for jewelry and watches.
            </p>
            <p className="custom-service__hours">
              Let us help you design the perfect piece.
            </p>

            <div className="custom-service__grid">
              <article className="custom-service__card">
                <div className="custom-service__icon-wrap" aria-hidden="true">
                  <svg
                    className="custom-service__icon"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="22.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <path
                      d="M16 32L32 16"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                    <path
                      d="M16 16L32 32"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                    <path
                      d="M24 12V16"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                    <path
                      d="M24 32V36"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                    <path
                      d="M12 24H16"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                    <path
                      d="M32 24H36"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <h3 className="custom-service__card-title">
                  Jewelry Customization
                </h3>
                <p className="custom-service__desc">
                  Design your perfect piece of jewelry with our expert
                  craftsmen. From engagement rings to personalized necklaces, we
                  bring your vision to life.
                </p>
              </article>

              <article className="custom-service__card">
                <div className="custom-service__icon-wrap" aria-hidden="true">
                  <svg
                    className="custom-service__icon"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="24"
                      cy="24"
                      r="22.5"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <circle
                      cx="24"
                      cy="24"
                      r="12"
                      stroke="currentColor"
                      strokeWidth="1"
                    />
                    <path
                      d="M24 16V24L30 28"
                      stroke="currentColor"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="custom-service__card-title">
                  Watch Customization
                </h3>
                <p className="custom-service__desc">
                  Personalize your timepiece with custom engraving, dial
                  designs, and strap options to make it truly yours.
                </p>
              </article>
            </div>
          </div>
        </section>

        <section className="custom-service__gallery" aria-label="Gallery">
          <div className="custom-service__gallery-inner">
            <h2 className="custom-service__gallery-title">Our Custom Pieces</h2>
            <div className="custom-service__gallery-grid">
              {JEWELRY_IMAGES.map((src, index) => (
                <div key={index} className="custom-service__gallery-item">
                  <img
                    src={src}
                    alt={`Custom jewelry piece ${index + 1}`}
                    className="custom-service__gallery-img"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          className="custom-service__contact-section"
          aria-labelledby="contact-heading"
        >
          <div className="custom-service__contact-inner">
            <div className="custom-service__contact">
              <h3
                id="contact-heading"
                className="custom-service__contact-title"
              >
                Get in Touch
              </h3>
              <p className="custom-service__contact-text">
                Ready to start your customization journey? Contact us today to
                discuss your ideas.
              </p>
              <p className="custom-service__email">
                <a
                  className="custom-service__email-link"
                  href="mailto:works@mindredlane.watch"
                >
                  works@mindredlane.watch
                </a>
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default CustomService;
